export const CalcularMora = (diasMora: number, cuota: number, porcentajeMora: number) => 
    (diasMora < 0) 
        ? (cuota * porcentajeMora / 30 * Math.abs(diasMora)) 
        : 0